import { c as _c } from "react/compiler-runtime";
import { IcoGlobe16, IcoPinMarker16 } from '@onefootprint/icons';
import { Divider, Form, InlineAlert } from '@onefootprint/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { acceptsSomeDocument, ID_DOC_KINDS_IN_DISPLAY_ORDER } from '../id-doc-kinds';
import CountrySpecificIdDocPicker from './country-specific-id-doc-picker';
import type { FormData } from './id-docs.types';
type AcceptedDocumentsSectionProps = {
  setIsCountryPickerActive: (isActive: boolean) => void;
};
const AcceptedDocumentsSection = t0 => {
  const $ = _c(82);
  const {
    setIsCountryPickerActive
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectDocument.acceptedDocuments"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "id_document"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    t: tDocs
  } = useTranslation("common", t2);
  const {
    control,
    getValues,
    setValue
  } = useFormContext();
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["scope", "global", "country"];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== control) {
    t4 = {
      control,
      name: t3
    };
    $[3] = control;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const [scope, global, country] = useWatch(t4);
  const isAnyCountry = scope === "any_country";
  let t5;
  if ($[5] !== getValues || $[6] !== setValue) {
    t5 = event => {
      if (event.target.value === "any_country" && getValues("global").length === 0) {
        setValue("global", ID_DOC_KINDS_IN_DISPLAY_ORDER, {
          shouldDirty: true
        });
      }
    };
    $[5] = getValues;
    $[6] = setValue;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const handleScopeChange = t5;
  let t6;
  if ($[8] !== t) {
    t6 = t(_temp);
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <div className="text-label-2 text-primary">{t6}</div>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t) {
    t8 = t(_temp2);
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <div className="text-body-2 text-tertiary">{t8}</div>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t7 || $[17] !== t9) {
    t10 = <div className="flex flex-col gap-1">{t7}{t9}</div>;
    $[16] = t7;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <IcoGlobe16 color="tertiary" />;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t) {
    t12 = t(_temp3);
    $[20] = t;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12) {
    t13 = <span className="flex items-center gap-2">{t11}{t12}</span>;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t) {
    t14 = t(_temp4);
    $[24] = t;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t13 || $[27] !== t14) {
    t15 = {
      value: "any_country",
      label: t13,
      hint: t14
    };
    $[26] = t13;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <IcoPinMarker16 color="tertiary" />;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t) {
    t17 = t(_temp5);
    $[30] = t;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t17) {
    t18 = <span className="flex items-center gap-2">{t16}{t17}</span>;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== t) {
    t19 = t(_temp6);
    $[34] = t;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== t18 || $[37] !== t19) {
    t20 = {
      value: "specific_countries",
      label: t18,
      hint: t19
    };
    $[36] = t18;
    $[37] = t19;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== t15 || $[40] !== t20) {
    t21 = [t15, t20];
    $[39] = t15;
    $[40] = t20;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== handleScopeChange || $[43] !== t21) {
    t22 = <Form.RadioGroup name="scope" options={t21} onChange={handleScopeChange} />;
    $[42] = handleScopeChange;
    $[43] = t21;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Divider />;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== isAnyCountry || $[47] !== t || $[48] !== tDocs) {
    t24 = isAnyCountry && <><div className="flex flex-col gap-3"><div className="text-label-3 text-primary">{t(_temp7)}</div><Form.CheckboxGroup name="global" options={ID_DOC_KINDS_IN_DISPLAY_ORDER.map(value => ({
          label: tDocs($_6 => $_6[value]),
          value
        }))} className="flex flex-wrap gap-x-4 gap-y-2" /></div><Divider /></>;
    $[46] = isAnyCountry;
    $[47] = t;
    $[48] = tDocs;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== isAnyCountry || $[51] !== t) {
    t25 = isAnyCountry ? t(_temp8) : t(_temp9);
    $[50] = isAnyCountry;
    $[51] = t;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== t25) {
    t26 = <div className="text-label-3 text-primary">{t25}</div>;
    $[53] = t25;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  let t27;
  if ($[55] !== isAnyCountry || $[56] !== t) {
    t27 = isAnyCountry ? t(_temp10) : t(_temp11);
    $[55] = isAnyCountry;
    $[56] = t;
    $[57] = t27;
  } else {
    t27 = $[57];
  }
  let t28;
  if ($[58] !== t27) {
    t28 = <div className="text-body-3 text-tertiary">{t27}</div>;
    $[58] = t27;
    $[59] = t28;
  } else {
    t28 = $[59];
  }
  let t29;
  if ($[60] !== t26 || $[61] !== t28) {
    t29 = <div className="flex flex-col gap-1">{t26}{t28}</div>;
    $[60] = t26;
    $[61] = t28;
    $[62] = t29;
  } else {
    t29 = $[62];
  }
  let t30;
  if ($[63] !== setIsCountryPickerActive) {
    t30 = <CountrySpecificIdDocPicker setIsPickerActive={setIsCountryPickerActive} />;
    $[63] = setIsCountryPickerActive;
    $[64] = t30;
  } else {
    t30 = $[64];
  }
  let t31;
  if ($[65] !== t29 || $[66] !== t30) {
    t31 = <div className="flex flex-col gap-3">{t29}{t30}</div>;
    $[65] = t29;
    $[66] = t30;
    $[67] = t31;
  } else {
    t31 = $[67];
  }
  let t32;
  if ($[68] !== country || $[69] !== global || $[70] !== isAnyCountry || $[71] !== scope || $[72] !== t) {
    t32 = !acceptsSomeDocument({
      scope,
      global,
      country
    }) && <InlineAlert variant="warning">{isAnyCountry ? t(_temp12) : t(_temp13)}</InlineAlert>;
    $[68] = country;
    $[69] = global;
    $[70] = isAnyCountry;
    $[71] = scope;
    $[72] = t;
    $[73] = t32;
  } else {
    t32 = $[73];
  }
  let t33;
  if ($[74] !== t22 || $[75] !== t24 || $[76] !== t31 || $[77] !== t32) {
    t33 = <div className="flex flex-col gap-4 p-3 border border-tertiary rounded-md">{t22}{t23}{t24}{t31}{t32}</div>;
    $[74] = t22;
    $[75] = t24;
    $[76] = t31;
    $[77] = t32;
    $[78] = t33;
  } else {
    t33 = $[78];
  }
  let t34;
  if ($[79] !== t10 || $[80] !== t33) {
    t34 = <section className="flex flex-col gap-3">{t10}{t33}</section>;
    $[79] = t10;
    $[80] = t33;
    $[81] = t34;
  } else {
    t34 = $[81];
  }
  return t34;
};
export default AcceptedDocumentsSection;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.subtitle;
}
function _temp3($_1) {
  return $_1.scope.anyCountry.label;
}
function _temp4($_2) {
  return $_2.scope.anyCountry.hint;
}
function _temp5($_3) {
  return $_3.scope.specificCountries.label;
}
function _temp6($_4) {
  return $_4.scope.specificCountries.hint;
}
function _temp7($_5) {
  return $_5.documents;
}
function _temp8($_7) {
  return $_7.exceptions.title;
}
function _temp9($_8) {
  return $_8.countries.title;
}
function _temp10($_9) {
  return $_9.exceptions.hint;
}
function _temp11($_10) {
  return $_10.countries.hint;
}
function _temp12($_11) {
  return $_11.errors.noDocuments;
}
function _temp13($_12) {
  return $_12.errors.noCountries;
}